import { useAuth } from '../context/AuthContext';

export default function TestAuth() {
  const { user, token, isAuthenticated, isLoading } = useAuth();

  return (
    <div className="max-w-7xl mx-auto px-6 py-8">
      <h1 className="text-3xl font-bold mb-4">Тест аутентификации</h1>
      
      <div className="space-y-4">
        <div className="p-4 bg-gray-50 rounded-lg">
          <h2 className="font-semibold mb-2">Состояние загрузки:</h2>
          <p>isLoading: {isLoading ? 'true' : 'false'}</p>
        </div>
        
        <div className="p-4 bg-gray-50 rounded-lg">
          <h2 className="font-semibold mb-2">Аутентификация:</h2>
          <p>isAuthenticated: {isAuthenticated ? 'true' : 'false'}</p>
        </div>
        
        <div className="p-4 bg-gray-50 rounded-lg">
          <h2 className="font-semibold mb-2">Токен:</h2>
          <p className="break-all">{token || 'null'}</p>
        </div>
        
        <div className="p-4 bg-gray-50 rounded-lg">
          <h2 className="font-semibold mb-2">Пользователь:</h2>
          <pre className="whitespace-pre-wrap">{JSON.stringify(user, null, 2)}</pre>
        </div>
        
        <div className="p-4 bg-gray-50 rounded-lg">
          <h2 className="font-semibold mb-2">localStorage:</h2>
          <p>auth_token: {localStorage.getItem('auth_token') ? 'есть' : 'нет'}</p>
          <p>auth_user: {localStorage.getItem('auth_user') ? 'есть' : 'нет'}</p>
        </div>
      </div>
    </div>
  );
}
